import { UserProfile } from '@/__generated_graphql__/graphql';
import { COOKIES, PROFILE_MODES, ProfileMode } from '@/constants/common';
import { CookiesUtils } from '@/utils/helpers/cookies';
import { ProfileFormatter } from '@/utils/helpers/profile';

export const isValidProfileMode = (value: unknown): value is ProfileMode =>
  value === PROFILE_MODES.COMPANY || value === PROFILE_MODES.CANDIDATE;

export const getStoredProfileMode = (): ProfileMode | null => {
  const cookie = CookiesUtils.get(COOKIES.PROFILE_MODE);
  return isValidProfileMode(cookie) ? cookie : null;
};

export const getAvailableModes = (
  profile: UserProfile | undefined
): ProfileMode[] => {
  if (!profile) return [];

  const modes: ProfileMode[] = [];

  if (ProfileFormatter.isProfileCompany(profile)) {
    modes.push(PROFILE_MODES.COMPANY);
  }

  if (ProfileFormatter.isProfileCandidate(profile)) {
    modes.push(PROFILE_MODES.CANDIDATE);
  }

  return modes;
};

export const getDefaultMode = (
  profile: UserProfile | undefined
): ProfileMode | null => {
  if (!profile) return null;

  if (ProfileFormatter.isProfileBoth(profile)) {
    return PROFILE_MODES.COMPANY;
  }

  if (ProfileFormatter.isProfileCompany(profile)) {
    return PROFILE_MODES.COMPANY;
  }

  if (ProfileFormatter.isProfileCandidate(profile)) {
    return PROFILE_MODES.CANDIDATE;
  }

  return null;
};
